export default "__VITE_ASSET__DaZ9EY0z__"